<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
    <tablita @cargar="cargar($event)" @ver_documento="ver_documento($event)" @ver_guia_origen="ver_guia_origen($event)"
      @ver_formulario_pcc="verFormularioPcc($event)" @revisar_formulario_pcc="abrirFormularioPcc($event)"
      @cargar_url="cargar_url($event)" @nuevo="crear" @editar="editar($event)" @pagina="update_pagina($event)"
      @refresh="refrescar($event)" :configuracion="configuracion_tabla" :cols="columnas">
      <template v-slot:numero_guia_reemplazadas="{ item: guia }">
        &nbsp;
        <template v-for="(reemplazada, i) in guia.historicas">
          <span v-if="i !== 0"> - </span>
          <span>{{ reemplazada.numero_guia }}&nbsp;</span>
          <button class="btn btn-danger btn-sm" type="button" title="" @click="abrirPdf(reemplazada.url)">
            <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
          </button>
        </template>
      </template>
    </tablita>
    <FormularioPccModal :formulario_pcc="formulario_pcc" modal-id="formularioPccModalGuias" modo="standalone"
      :mp_tipos_id="mp_tipos_id" @actualizado="onFormularioPccActualizado" />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
import FormularioPccModal from "../../components/FormularioPCC/FormularioPccModal.vue";
import Swal from "sweetalert2";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    formulario_pcc: {},
    mp_tipos_id: null,
    columnas: [
      {
        key: "fecha",
        label: "Fecha",
        busqueda: "",
        tipo: "datetime",
        searchable: true,
        path: "fecha",
      },
      {
        key: "numero_guia_traslado",
        label: "N° Guía Traslado",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "numero_guia_traslado",
      },
      {
        key: "numero_guia",
        label: "N° Guía",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "numero_guia_original",
      },
      {
        slot: "numero_guia_reemplazadas",
        key: "numero_guia_reemplazadas",
        label: "N° Guías Reemplazadas",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "numero_guia_reemplazadas",
      },
      {
        key: "tickets_id",
        label: "Ticket",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/tickets",
        parametro: "codigo_ticket",
        searchable: true,
        path: "ticket.codigo_ticket",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "codigo_ticket",
      },
      {
        key: "empresas_id",
        label: "Empresa",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/empresas",
        parametro: "nombre",
        append_parametro: "&tipo_empresa_ids=4",
        searchable: true,
        path: "empresa_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "dependencias_id",
        label: "Sucursal",
        busqueda: "",
        tipo: "select-loadable-dependiente",
        columna_dependiente: "empresas_id",
        ruta: "/dependencias",
        parametro: "nombre",
        searchable: true,
        path: "sucursal_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },

      {
        key: "peso_informado",
        label: "Peso Informado",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "peso_informado",
      },
      {
        key: "peso_real",
        label: "Peso Real",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "peso_real",
      },
      {
        key: "restricciones_id",
        label: "Restricción",
        busqueda: [],
        tipo: "multiselect",
        searchable: true,
        path: "restricciones_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "cantidad_bins",
        label: "Bins",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "cantidad_bins",
      },
    ],
    lista: [],
    links: [],
    tickets: [],
    restricciones: [],
    inputs: [
      /* {cols:4,tipo:'numero',key:'codigo_ticket',valor:'',label:'N° Ticket (*)'},
          {cols:4,tipo:'select',key:'ciclo_ticket',valor:'',label:'Ciclo ticket (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'} */
    ],
    configuracion_modal: {
      titulo: "",
      ancho: "xl",
      ruta: "/guias",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Guias",
      titulo_boton: "Crear Guia",
      clase_boton: "btn-primary",
      btn_nuevo: false,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.$emit("spinner", true);
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });

    //this.cargar_restricciones();

    //this.cargar_tickets();
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        const founded = storage.columnas.find((c) => c.key == col.key);
        if (!founded) return;

        col.busqueda = founded.val;
      });
    }
    console.log("storage", storage);

    this.cargar_restricciones();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_tickets() {
      await this.axios
        .get(`${this.api}/tickets?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.tickets = res.data.data.data;
            this.$set(this.columnas[2], "opciones", this.tickets);
          }
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_restricciones();
    },

    async cargar_restricciones() {
      await this.axios
        .get(`${this.api}/restricciones?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.restricciones = res.data.data.data;
            this.$set(this.columnas[7], "opciones", this.restricciones);
          }
        })
        .catch((e) => {
          //console.log(e);
        });
      this.$emit("cargar");
      //this.cargar(this.query);
    },

    async cargar($event) {
      //console.log('cargando',$event);

      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/guias${$event}`;
      this.lista = [];

      await this.axios
        .get(`${this.api}/guias${$event}`, this.cabeceras_json)
        .then((res) => {
          if (res) {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            this.inicializar_tabla({
              columnas: this.columnas,
              lista: this.lista,
              links: this.links,
              botones: this.botones,
            });
          }
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            if (res) {
              this.lista = res.data.data.data;
              this.links = res.data.data.links;
              this.setear_lista({ lista: this.lista, links: this.links });
            }
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/guias`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/guias/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    ver_documento(event) {
      window.open(`${event.item.url}`, "_blank");
    },

    ver_guia_origen(event) {
      window.open(`${event.item.link_guia_origen}`, "_blank");
    },

    abrirFormularioPcc(evento) {
      this.formulario_pcc = evento.item.formulario_pcc;
      console.log('pcc', this.formulario_pcc)
      this.mp_tipos_id = evento.item.mp_tipos_id;
      this.$nextTick(() => {
        $("#formularioPccModalGuias").modal("show");
      });
    },

    async verFormularioPcc(evento) {
      const url = `${this.api}/formulario/pcc/${evento.item.formulario_pcc.id}`;

      const ventana = window.open(url, '_blank');

      if (!ventana) {
        Swal.fire({
          icon: 'warning',
          title: 'Ventana bloqueada',
          text: 'El navegador bloqueó la ventana del PDF. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
        });
      }
    },

    onFormularioPccActualizado() {
      // el componente ya mutó guiaSeleccionada.formulario_pcc por referencia (misma
      // instancia que el item dentro de la lista de la tabla); no se requiere acción adicional.
    },

    tieneAccionCorrectiva(f) {
      // Se recalcula en vivo con los valores actuales del formulario (no con el campo
      // "tiene_accion_correctiva" que llega del backend, que queda desactualizado apenas
      // el usuario cambia un radio en el modal sin guardar todavía).
      return [
        f.subproducto_guia_despacho_accion_correctiva,
        f.subproducto_declaracion_jurada_accion_correctiva,
        f.mortalidad_guia_despacho_accion_correctiva,
        f.mortalidad_declaracion_jurada_accion_correctiva,
        f.mortalidad_cam_accion_correctiva,
      ].some((v) => v && String(v).trim().length > 0);
    },

    puedeFirmarPCC(item) {
      const f = item.formulario_pcc;
      if (!f || !this.usuario || !this.usuario.cargo_id) return false;
      const cargoId = this.usuario.cargo_id;

      if (cargoId === 3 || cargoId === 4) {
        // Condición 1:
        // Romanero firmó + existe NO CUMPLE + Jefe de Trazabilidad firmó
        const flujoConNoCumple =
          !!f.check_romanero &&
          !!f.existe_no_cumple &&
          !!f.check_jefe_trazabilidad;

        // Condición 2:
        // Romanero firmó + no existe NO CUMPLE
        const flujoSinNoCumple =
          !!f.check_romanero &&
          !f.existe_no_cumple;

        // En ambos casos, el Jefe PAC no debe haber firmado previamente
        return (
          !f.check_jefe_pac &&
          (flujoConNoCumple || flujoSinNoCumple)
        );
      }

      if (cargoId === 2) {
        // Jefe Trazabilidad: disponible solo si Romanero firmo y existe
        // al menos una acción correctiva, hasta que él mismo firme.
        return (
          !!f.check_romanero &&
          f.existe_no_cumple &&
          !f.check_jefe_trazabilidad
        );
      }

      return false;
    },

    abrirPdf(link) {
      window.open(link, "_blank");
    },
    ...mapActions([
      "inicializar_tabla",
      "setear_lista",
      "setear_inputs",
      "actualizar_columnas",
    ]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
    FormularioPccModal,
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json", "filtros_rom", "usuario"]),
    botones() {
      return [
        //{label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
        {
          label: "Ver Documento",
          clase: "btn-danger",
          evento: "ver_documento",
          icono: "fas fa-file",
        },
        {
          label: "Ver Guia Origen",
          clase: "btn-danger",
          evento: "ver_guia_origen",
          icono: "fas fa-file",
          condicion: "mostrar_guia_origen",
        },
        {
          label: "Formulario PCC",
          clase: "btn-info",
          evento: "ver_formulario_pcc",
          icono: "fas fa-file-alt",
          condicion: "tiene_formulario_pcc",
        },
        {
          label: "Firmar",
          clase: "btn-warning",
          evento: "revisar_formulario_pcc",
          icono: "fas fa-clipboard-check",
          condicion: (item) => this.puedeFirmarPCC(item),
        },
      ];
    },
    /* query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    }, */
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }
        //console.log(`parametro: ${c.key}, busqueda: ${c.busqueda}`);

        if (
          c.busqueda !== undefined &&
          c.busqueda !== null &&
          c.busqueda !== "" &&
          c.busqueda.toString().length > 0
        ) {
          if (c.key == "tipo_empresa") {
            string += `${and}${c.busqueda}=1`;
          } else {
            string += `${and}${c.key}=${c.busqueda}`;
          }
        }
      });
      string += `&limit=${this.paginacion}`;
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>